import { render, staticRenderFns } from "./IndexModal.vue?vue&type=template&id=45b4eb02"
import script from "./IndexModal.vue?vue&type=script&lang=js"
export * from "./IndexModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports